<app-modal-shell [config]="modalConfig">
  <div modal-content class="relationship-sync-dialog">
    <p class="relationship-sync-dialog__intro">
      Elegí dónde querés registrar la actualización de la relación con {{ data.relatedPersonName }}.
    </p>

    <div class="relationship-sync-dialog__options" role="radiogroup" aria-label="Alcance de la actualización">
      <button
        *ngIf="data.canUpdateRelatedPerson"
        type="button"
        class="relationship-sync-dialog__option"
        [class.relationship-sync-dialog__option--selected]="selectedResult === 'both'"
        role="radio"
        [attr.aria-checked]="selectedResult === 'both'"
        (click)="select('both')">
        <mat-icon class="relationship-sync-dialog__option-icon">sync</mat-icon>
        <span class="relationship-sync-dialog__option-copy">
          <strong>Actualizar ambos miembros</strong>
          <span>Mantiene las dos fichas vinculadas.</span>
        </span>
        <mat-icon class="relationship-sync-dialog__selection">
          {{ selectedResult === 'both' ? 'radio_button_checked' : 'radio_button_unchecked' }}
        </mat-icon>
      </button>

      <button
        type="button"
        class="relationship-sync-dialog__option"
        [class.relationship-sync-dialog__option--selected]="selectedResult === 'current'"
        role="radio"
        [attr.aria-checked]="selectedResult === 'current'"
        (click)="select('current')">
        <mat-icon class="relationship-sync-dialog__option-icon">person</mat-icon>
        <span class="relationship-sync-dialog__option-copy">
          <strong>Actualizar sólo este miembro</strong>
          <span>No modifica la ficha de {{ data.relatedPersonName }}.</span>
        </span>
        <mat-icon class="relationship-sync-dialog__selection">
          {{ selectedResult === 'current' ? 'radio_button_checked' : 'radio_button_unchecked' }}
        </mat-icon>
      </button>
    </div>
  </div>

  <ng-container modal-actions>
    <button mat-button type="button" (click)="close('cancel')">
      Cancelar
    </button>
    <button mat-flat-button type="button" color="primary" [disabled]="!selectedResult" (click)="continue()">
      Continuar
    </button>
  </ng-container>
</app-modal-shell>
